import frontBumper from '~/assets/icons/front_bumper.svg';
import rearBumper from '~/assets/icons/rear_bumper.svg';
import sideSkirts from '~/assets/icons/side_skirts.svg';
import bonnet from '~/assets/icons/bonnet.svg';
import spoiler from '~/assets/icons/spoiler.svg';
import frontLight from '~/assets/icons/front_light.svg';
import rearLight from '~/assets/icons/rear_light.svg';
import kit from '~/assets/icons/kit.svg';
import disks from '~/assets/icons/disks.svg';

export enum TuningTypes {
	FrontBumper = 'front_bumper',
	RearBumper = 'rear_bumper',
	SideSkirts = 'side_skirts',
	Bonnet = 'bonnet',
	Spoiler = 'spoiler',
	FrontLight = 'front_light',
	RearLight = 'rear_light',
	Disks = 'wheels',
	Kit = 'kit',
}

export const tuningData = {
	[TuningTypes.FrontBumper]: {
		label: 'Передний бампер',
		img: frontBumper,
	},
	[TuningTypes.RearBumper]: {
		label: 'Задний бампер',
		img: rearBumper,
	},
	[TuningTypes.SideSkirts]: {
		label: 'Пороги',
		img: sideSkirts,
	},
	[TuningTypes.Bonnet]: {
		label: 'Капот',
		img: bonnet,
	},
	[TuningTypes.Spoiler]: {
		label: 'Спойлер',
		img: spoiler,
	},
	[TuningTypes.FrontLight]: {
		label: 'Передние фары',
		img: frontLight,
	},
	[TuningTypes.RearLight]: {
		label: 'Задние фары',
		img: rearLight,
	},
	[TuningTypes.Kit]: {
		label: 'Наборы',
		img: kit,
	},
	[TuningTypes.Disks]: {
		label: 'Диски',
		img: disks,
	},
};
